"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailClient = void 0;
const _ = require("lodash");
const inversify_1 = require("inversify");
// TODO: move this to a more appropriate place once we bring in inventory,
//  stocktake purchase orders etc
let RetailClient = class RetailClient {
    /**
     * The named functions will be replaced with a function that throws.
     * Upon invoking, the original method will be reinstated to help demonstrate
     * how the code recovers.
     */
    mockErrorResponse(functionNames) {
        // replace function with our own
        functionNames.map((name) => {
            const originalFunc = _.get(this, name);
            // replace with a function that restores
            _.set(this, name, async () => {
                _.set(this, name, originalFunc);
                throw new Error(name);
            });
        });
    }
    /**
     * The named functions will be replaced with a function that throws.
     * Upon invoking, the original method will be reinstated to help demonstrate
     * how the code recovers.
     */
    mockSocketErrorResponse(functionNames) {
        functionNames.map(({ module, functionName }) => {
            // @ts-ignore
            const originalSyncMetaData = this[module][functionName]();
            const errorSyncMetaDAta = _.cloneDeep(originalSyncMetaData);
            errorSyncMetaDAta.mockData = new Error();
            // @ts-ignore
            this[module][functionName] = () => {
                // @ts-ignore
                this[module][functionName] = () => originalSyncMetaData;
                return errorSyncMetaDAta;
            };
        });
    }
};
__decorate([
    (0, inversify_1.inject)("HttpConnection")
], RetailClient.prototype, "httpConnection", void 0);
__decorate([
    (0, inversify_1.inject)("WebSocketConnection")
], RetailClient.prototype, "webSocketConnection", void 0);
__decorate([
    (0, inversify_1.inject)("SyncModule")
], RetailClient.prototype, "sync", void 0);
__decorate([
    (0, inversify_1.inject)("AuthModule")
], RetailClient.prototype, "auth", void 0);
__decorate([
    (0, inversify_1.inject)("GeoModule")
], RetailClient.prototype, "geo", void 0);
__decorate([
    (0, inversify_1.inject)("LegalsModule")
], RetailClient.prototype, "legals", void 0);
__decorate([
    (0, inversify_1.inject)("RetailSalesOrdersModule")
], RetailClient.prototype, "retailSalesOrders", void 0);
__decorate([
    (0, inversify_1.inject)("RetailCustomersModule")
], RetailClient.prototype, "retailCustomers", void 0);
__decorate([
    (0, inversify_1.inject)("RetailLocationsModule")
], RetailClient.prototype, "retailLocations", void 0);
__decorate([
    (0, inversify_1.inject)("RetailProductsModule")
], RetailClient.prototype, "retailProducts", void 0);
__decorate([
    (0, inversify_1.inject)("ContentModule")
], RetailClient.prototype, "content", void 0);
RetailClient = __decorate([
    (0, inversify_1.injectable)()
], RetailClient);
exports.RetailClient = RetailClient;
//# sourceMappingURL=RetailClient.js.map